import React, { useContext, useEffect, useState } from 'react'
import {auth, provider, db, storage} from '../Firebase'
import { signInWithPopup , signOut} from 'firebase/auth'
import {addDoc, getDocs, collection, deleteDoc, deleteField, doc, where, updateDoc, getDoc, orderBy, query,setDoc, serverTimestamp, onSnapshot} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import {v4} from "uuid"
import { translate, generateText, sendEmailBackend } from "../api/backend";


const AuthContext = React.createContext()


export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({children}) {

    const [currentUser, setCurrentUser] = useState()
    const [authReady, setAuthReady] = useState(false);
    const [listChallenges] = useState()
    const [page, setPage] = useState('')
    const [newChallengeM, setNewChallengeM] = useState('')
    const [screenSize, setScreenSize] = useState(getCurrentDimension());





    const [isLoading, setIsLoading] = useState(false)
    const [isProducts, setIsProducts] = useState(false)

    const productsCollection = collection(db,"products")
    const categoryCollection = collection(db,"categories")
    const restaurantCollection = collection(db,"restaurants")
    const [photoUrl, setPhotoUrl] = useState("")

    const [articles, setArticles] = useState([]);
    const [currentArticle, setCurrentArticle] = useState({});
    const [categoriesCMS, setCategoriesCMS] = useState([]);

    


    const [listRestaurants, setListRestaurants] = useState()
    const [currentRestaurant, setCurrentRestaurant] = useState()
    const [listProducts, setListProducts] = useState()
    const [currentProduct, setCurrentProduct] = useState()
    const [listCategories, setListCategories] = useState()
    const [currentCategory, setCurrentCategory] = useState()
    const [productM, setProductM] = useState('')
    const [categoryM, setCategoryM] = useState('')
    const [restaurantM, setRestaurantM] = useState('')
    const [language, setLanguage] = useState('');
    const [languages] = useState([
      {
        name: 'Anglais',
        origin: 'English',
        code:'en'
      },
      {
        name:'Espagnol',
        origin: 'Español',
        code:'es'
      },
      {
        name:'Italien',
        origin: 'Italiano',
        code:'it'
      },
      {
        name: 'Portugais',
        origin: 'Portuguese',
        code:'pt'
      },
      {
        name:'Allemand',
        origin: 'Deutsch',
        code:'de'
      },
      {
        name:'Néerlandais',
        origin: 'Nederlands',
        code:'nl'
      },
      {
        name: 'Chinois',
        origin: '中国人',
        code:'zh'
      },
      {
        name:'Arabe',
        origin:'العربية',
        code:'ar'
      },
    ]);

    const [translated , setTranslated] = useState({})
    const [translated2 , setTranslated2] = useState({})
    const [generated , setGenerated] = useState('')
    const [isgenerating , setIsGenerating] = useState(false)

    const [translatedOpt , setTranslatedOpt] = useState([])

    const [basket , setBasket] = useState([])
    const [userProfile, setUserProfile] = useState(null);
    const [userProfileLoading, setUserProfileLoading] = useState(true);
    const [ordersClient, setOrdersClient] = useState([]);

    const [ordersList, setOrdersList] = useState([]);
    const [orderMessage, setOrderMessage] = useState("");
    const [currentOrder, setCurrentOrder] = useState(null);
    const [platformSettings, setPlatformSettings] = useState(null)

    function getCurrentDimension(){
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
      }


      useEffect(() => {
        const updateDimension = () => {
          setScreenSize(getCurrentDimension());
        };
      
        window.addEventListener("resize", updateDimension);
      
        return () => {
          window.removeEventListener("resize", updateDimension);
        };
      }, []);






     function usernane (email) {
       let result = email.indexOf("@");
       let username = email.slice(0, result-2)
       return username


     } 

     function name (displayName) {
        let result = displayName.indexOf(" ");
        let name = displayName.slice(0, result)
        return name
 
      } 


      // Dans AuthContext.jsx (ou là où est ton AuthProvider)
// Remplace ta fonction signup() par celle-ci (garde le reste pareil)

async function signup() {
  setIsLoading(true);

  try {
    // 1) Popup Google
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const email = user.email || "";

    // 2) Vérif authorizedUsers (ton comportement actuel)
    const usersRef = collection(db, "authorizedUsers");
    const q = query(usersRef, where("email", "==", email));
    const querySnap = await getDocs(q);

    if (querySnap.empty) {
      // ❌ Pas autorisé
      try { await user.delete(); } catch {}
      await signOut(auth);
      alert("Accès refusé : votre adresse e-mail n'est pas autorisée.");
      return;
    }

    // ✅ Autorisé : injecte aussi dans Firestore /users/{uid}
    // finalizeSignup doit exister dans le même AuthProvider
    await finalizeSignup({
      user,
      role: "merchant",
      authProvider: "google",
      profile: {
        email: user.email || null,
        firstName: user.displayName ? user.displayName.split(" ")[0] : null,
        promoOptOut: false,
      },
    });

    // (tu voulais garder ça)

  } catch (error) {
    console.error("Erreur d'authentification :", error);
  } finally {
    setIsLoading(false);
  }
}


    

async function refreshUserProfile(uid) {
  if (!uid) {
    setUserProfile(null);
    setUserProfileLoading(false);
    return null;
  }

  setUserProfileLoading(true);
  try {
    const refUser = doc(db, "users", uid);
    const snap = await getDoc(refUser);

    if (snap.exists()) {
      const data = snap.data();
      setUserProfile(data);
      return data;
    }

    // ✅ aucun doc users/{uid} => on renvoie un "profil incomplet" (pas null)
    const fallback = {
      uid,
      role: null,
      authProvider: auth.currentUser?.providerData?.[0]?.providerId || null,
      phone: auth.currentUser?.phoneNumber || null,
      email: auth.currentUser?.email || null,
      firstName: auth.currentUser?.displayName
        ? auth.currentUser.displayName.split(" ")[0]
        : null,
      address: null,
      promoOptOut: null,
    
      __missingDoc: true,
    };

    setUserProfile(fallback);
    return fallback;
  } catch (e) {
    console.error("refreshUserProfile error:", e);
    setUserProfile(null);
    return null;
  } finally {
    setUserProfileLoading(false);
  }
}


// 3) upsertUserProfile: ne change pas createdAt si déjà existant + promoOptOut boolean strict
async function upsertUserProfile(profile) {
  if (!profile?.uid) throw new Error("Missing uid");

  const refUser = doc(db, "users", profile.uid);

  let existingCreatedAt = null;
  try {
    const snap = await getDoc(refUser);
    if (snap.exists()) existingCreatedAt = snap.data()?.createdAt || null;
  } catch {}

  await setDoc(
    refUser,
    {
      uid: profile.uid,
      role: profile.role || "customer",
      authProvider: profile.authProvider || "phone",
  
      phone: profile.phone ?? null,
      email: profile.email ?? null,
      firstName: profile.firstName ?? null,
      address: profile.address ?? null,
      promoOptOut:
        typeof profile.promoOptOut === "boolean" ? profile.promoOptOut : null,
      photoURL: profile.photoURL ?? null,
      displayName: profile.displayName ?? null,
  
      updatedAt: serverTimestamp(),
      createdAt: existingCreatedAt || serverTimestamp(),
    },
    { merge: true }
  );

  // ✅ synchro état local (utile pour fermer la modale automatiquement)
  await refreshUserProfile(profile.uid);
}


async function finalizeSignup({ user, role, authProvider, profile }) {
  if (!user?.uid) throw new Error("Missing firebase user");

  const payload = {
    uid: user.uid,
    role: role || "customer",
    authProvider: authProvider || "phone",
  
    phone: profile?.phone ?? user.phoneNumber ?? null,
    email: profile?.email ?? user.email ?? null,
    firstName: profile?.firstName ?? null,
    address: profile?.address ?? null,
    promoOptOut:
      typeof profile?.promoOptOut === "boolean" ? profile.promoOptOut : null,
    photoURL: user.photoURL ?? null,
    displayName: user.displayName ?? null,
  };

  await upsertUserProfile(payload);

  setCurrentUser(user);

  // legacy
  return payload;
}
  
// 5) isProfileComplete: ta règle “complet = firstName + email + promoOptOut boolean”
const isProfileComplete = (p) =>
  !!(
    p?.firstName &&
    p?.email &&
    p?.address &&
    typeof p?.promoOptOut === "boolean" &&
    !p?.__missingDoc // 🔥 IMPORTANT
  );

  async function afterPhoneOtpLogin(user) {
    if (!user?.uid) return null;
  
    setCurrentUser(user);
  
    // ⚠️ juste lire, pas créer
    const profile = await refreshUserProfile(user.uid);
  
    return profile;
  } 
  

  function signout() {
    setIsLoading(true);
  
    signOut(auth).then(() => {
      setCurrentUser(undefined);
  
      // ✅ important
      setUserProfile(null);
      setUserProfileLoading(false);
  
      setIsLoading(false);
    });
  }


    function postChallenges(number,creator, videos, user, active, url , picture, description) {
        setIsLoading(true)
        addDoc(productsCollection,{
            number,
           creator,
           videos,
            user,
            active,
            url,
            picture,
            description
                 } )
            .then((result) => {
        console.log(result)
        setIsLoading(false)
        setNewChallengeM("Nouveaux produits ajoutée !")
        })
    }


 ////////////////////new/////////////////////////////////////////////////////

 async function t(text, language) {
    try {
      const { translations } = await translate(text, language);
      const trans = translations[0].text;
      setTranslated(prev => ({
        ...prev,
        [language]: trans
      }));
      console.log("Traduction reçue:", trans);
    } catch (err) {
      console.error("translate error:", err);
    }
  }


  async function t2(text, language) {
    try {
      const { translations } = await translate(text, language);
      setTranslated2(prev => ({
        ...prev,
        [language]: translations[0].text
      }));
      console.log("Traduction reçue (t2):", translations[0].text);
    } catch (err) {
      console.error("translate error:", err);
    }
  }


  async function tOption(list, languages) {
    setTranslatedOpt([]);
    const translatedList = [];
    
    for (const item of list) {
      const translations = {};
      for (const lang of languages) {
        try {
          const { translations: tdata } = await translate(item.name, lang);
          translations[lang] = tdata[0].text;
        } catch {
          translations[lang] = item.name;
        }
      }
      translatedList.push({ ...item, translations });
      setTranslatedOpt([...translatedList]);
    }
  
    console.log("Liste traduite:", translatedList);
  }
  


 const getArticles = async () => {
    try {
      setIsLoading(true);
  
      const res = await fetch(
        `${process.env.REACT_APP_CMS_API_URL}/articles?populate=*&sort=publishedAt:desc`
      );
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
      const data = await res.json();
      setArticles(data.data);
      console.log(data.data); // Affiche bien les articles récupérés
    } catch (err) {
      console.error("Erreur lors du chargement des articles :", err);
    } finally {
      setIsLoading(false);
    }
  };
  



  const getArticle = async (slug) => {
    try {
      setIsLoading(true);
      const res = await fetch(`https://blog.fastlineapp.com/api/articles?filters[slug][$eq]=${slug}&populate=*`);
      const data = await res.json();
      setCurrentArticle(data.data[0]); // null si non trouvé
      console.log(currentArticle)
    } catch (err) {
      console.error("Erreur lors du chargement de l'article :", err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };


  const getCategoriesCMS = async () => {
    try {
      const res = await fetch('https://blog.fastlineapp.com/api/categories');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`); 
  
      const data = await res.json();
      setCategoriesCMS(data.data); // tu dois avoir useState pour setCategories
      console.log(data.data); // tu vois tes catégories ici
    } catch (err) {
      console.error("Erreur lors du chargement des catégories :", err);
    }
  };
  
  




async function ai(prompt) {
    setIsGenerating(true);
    try {
      const { result } = await generateText(prompt);
      setGenerated(result);
      console.log("Texte généré:", result);
    } catch (err) {
      console.error("generateText error:", err);
    } finally {
      setIsGenerating(false);
    }
  }




  const sendMessage = async (name, phone, day, hour, plan) => {
    console.log(name,phone, day , hour , plan )
    setIsLoading(true);
    try {
      await sendEmailBackend({ name, phone, day, hour, plan });
      console.log("Email envoyé via backend");
    } catch (err) {
      console.error("sendEmailBackend error:", err);
      alert("Une erreur est survenue, veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };




 function changeLanguage(language) {
    setLanguage(language)
    console.log(language)
}


function getRestaurant(id) {
  setIsLoading(true);
  const restaurant = doc(db, "restaurants", id);

  getDoc(restaurant).then((result) => {
    if (result.exists()) {
      setCurrentRestaurant({
        id: result.id,
        ...result.data(),
      });
    } else {
      setCurrentRestaurant(undefined);
    }
    setIsLoading(false);
  });
}


function updateRestaurantStripeData(id, data) {
  const restaurantDb = doc(db, "restaurants", id);

  return updateDoc(restaurantDb, data).then(() => {
    setCurrentRestaurant((prev) =>
      prev
        ? {
            ...prev,
            ...data,
          }
        : prev
    );
  });
}


    function getRestaurants() {
        setIsLoading(true)
        const restaurants = query(collection(db, "restaurants"),where("owner", "==", currentUser.uid),  orderBy("name"));
        getDocs(restaurants)
            .then((data) => {
                setListRestaurants(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
                setIsLoading(false)
            })
  
    }




    function getProducts(id) {
        setIsLoading(true)
        const products = query(collection(db, "products"), where("restaurant", "==", id),  orderBy("position"));
        getDocs(products)
            .then((data) => {
                setListProducts(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
                setIsLoading(false)
                setIsProducts(true)
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }


    function getProduct(id) {
      setIsLoading(true);
      setGenerated('');
    
      const product = doc(db, "products", id);
    
      getDoc(product).then((result) => {
        if (result.exists()) {
          setCurrentProduct({
            id: result.id,
            ...result.data(),
          });
        } else {
          setCurrentProduct(undefined);
        }
        setIsLoading(false);
      });
    }


    function getCategories(id) {
        setIsLoading(false)
        const categories = query(collection(db, "categories"),where("restaurant", "==", id), orderBy("position"), );
        getDocs(categories)
            .then((data) => {
                setListCategories(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
                setIsLoading(false)
            })
    }


    function getcategory(id) {
      setIsLoading(true);
      const category = doc(db, "categories", id);
    
      getDoc(category).then((result) => {
        if (result.exists()) {
          setCurrentCategory({
            id: result.id,
            ...result.data(),
          });
        } else {
          setCurrentCategory(undefined);
        }
        setIsLoading(false);
      });
    }






    async function postProduct(
      name,
      price,
      description,
      category,
      picture,
      status,
      position,
      restaurant,
      translated,
      translatedOpt,
      translated2,
      allergens,
      label,
      quantity,
      digitalFileName = '',
      isDigitalDownload = false,
      digitalFilePath = '',
      pictures = []
    ) {
      setIsLoading(true);

      try {
        const productRef = doc(productsCollection);

        await setDoc(productRef, {
          id: productRef.id,
          name,
          price,
          description,
          category,
          picture: pictures[0] || picture,
          pictures: pictures.length ? pictures : (picture ? [picture] : []),
          status,
          position,
          restaurant,
          translated,
          translatedOpt,
          translated2,
          allergens,
          label,
          quantity: Number(quantity || 0),

          digitalFileName,
          isDigitalDownload: !!isDigitalDownload,
          digitalFilePath,
        });
    
        setProductM("Nouveaux produit ajoutée.");
        setTimeout(() => {
          setProductM("");
        }, 3000);
    
        setPhotoUrl("");
        setTranslated({});
        setTranslated2({});
        setTranslatedOpt([]);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }






    function postCategory(name, restaurant, status, position, translated) {
      setIsLoading(true);
    
      const categoryRef = doc(categoryCollection);
    
      setDoc(categoryRef, {
        id: categoryRef.id,
        name,
        restaurant,
        status,
        position,
        translated
      }).then((result) => {
        console.log(result);
        setIsLoading(false);
        setCategoryM("Nouvelle catégorie ajoutée.");
        setTimeout(() => {
          setCategoryM("");
        }, 3000);
        setTranslated({});
      });
    }


    async function postRestaurant(
      owner,
      name,
      adress,
      type,
      hours,
      review,
      photo,
      status,
      isOpen,
      defaultL,
      translated,
      social,
      contact,
      productType
    ) {
      setIsLoading(true);
    
      try {
        const restaurantRef = doc(restaurantCollection);
    
        await setDoc(restaurantRef, {
          id: restaurantRef.id,
          owner,
          name,
          adress,
          type,
          hours,
          review,
          photo,
          status,
          isOpen,
          defaultL,
          translated,
          social,
          contact,
          productType,
          stripeAccountId: null,
          stripeOnboardingCompleted: false,
          stripeChargesEnabled: false,
          stripePayoutsEnabled: false,
          stripeDetailsSubmitted: false,
        });
    
        await setDoc(
          doc(db, "users", owner),
          {
            role: "merchant",
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
    
        await refreshUserProfile(owner);
        await getRestaurants();
    
        setIsLoading(false);
        setRestaurantM("Nouveaux restaurant ajoutée !");
        setTimeout(() => {
          setRestaurantM("");
        }, 3000);
        setPhotoUrl("");
        setTranslated({});
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }



    function updateRestaurant(
      id,
      owner,
      name,
      adress,
      type,
      hours,
      review,
      photo,
      status,
      isOpen,
      defaultL,
      translated,
      social,
      contact,
      productType,
      paymentEnabled,
      deliveryEnabled,
      deliveryFee,
      minOrderPrice,
      enableTable,
      enableTakeaway,
      enableDelivery,
      preparationTime,
      deliveryTimeUnit,
      imageDisplay
    ) {
      setIsLoading(true);
    
      const restaurantDb = doc(db, "restaurants", id);
    
      const fields = {
        id,
        owner,
        name,
        adress,
        type,
        hours,
        review,
        photo,
        status,
        isOpen,
        defaultL,
        translated,
        social,
        contact,
        productType,
    
        paymentEnabled: !!paymentEnabled,
        deliveryEnabled: !!deliveryEnabled,
        deliveryFee: Number(deliveryFee || 0),
        minOrderPrice: Number(minOrderPrice || 0),
    
        enableTable: !!enableTable,
        enableTakeaway: !!enableTakeaway,
        enableDelivery: !!enableDelivery,
    
        preparationTime: Number(preparationTime || 0),
        deliveryTimeUnit: deliveryTimeUnit || "minutes",
        // Seule la page Informations envoie ce réglage : les autres pages ne doivent pas l'écraser.
        ...(imageDisplay ? { imageDisplay } : {}),
      };
    
      updateDoc(restaurantDb, fields)
        .then(() => {
          setCurrentRestaurant((prev) =>
            prev
              ? {
                  ...prev,
                  ...fields,
                }
              : prev
          );
    
          setIsLoading(false);
          setRestaurantM("Sauvegardé.");
          setTimeout(() => {
            setRestaurantM("");
          }, 3000);
          setPhotoUrl("");
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }

  


    function updateCategory(id, name, restaurantId, status, position, translated) {
      setIsLoading(true);
      const categoryDb = doc(db, "categories", id);
    
      const fields = {
        id,
        name: name,
        restaurant: restaurantId,
        status: status,
        position: position,
        translated: translated,
      };
    
      updateDoc(categoryDb, fields).then((result) => {
        console.log(result);
        setIsLoading(false);
        setCategoryM("Sauvegardé.");
        setTimeout(() => {
          setCategoryM("");
        }, 3000);
      });
    }


    function updateProduct(
      id,
      name,
      price,
      description,
      category,
      picture,
      status,
      position,
      translated,
      translatedOpt,
      translated2,
      allergens,
      label,
      quantity,
      digitalFileName = '',
      isDigitalDownload = false,
      digitalFilePath = '',
      pictures = []
    ) {
      setIsLoading(true);

      const productDb = doc(db, "products", id);

      const fields = {
        id,
        name,
        price,
        description,
        category,
        picture: pictures[0] || picture,
        pictures: pictures.length ? pictures : (picture ? [picture] : []),
        status,
        position,
        translated,
        translatedOpt,
        translated2,
        allergens,
        label,
        quantity: Number(quantity || 0),

        // Purge le lien permanent hérité : il était lisible par tous les visiteurs du menu.
        digitalFileUrl: deleteField(),
        digitalFileName,
        isDigitalDownload: !!isDigitalDownload,
        digitalFilePath,
      };
    
      updateDoc(productDb, fields)
        .then(() => {
          setIsLoading(false);
          setProductM("Sauvegardé.");
          setTimeout(() => {
            setProductM("");
          }, 3000);
          setPhotoUrl("");
          setTranslated({});
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }


    function deleteProduct(id) {
        const productDb = doc(db, "products", id)

        deleteDoc(productDb)
            .then((result) => {
                console.log(result)
                setIsLoading(false)
                window.history.back()
            })
    }


    function deleteRestaurant(id) {
        const restaurantDb = doc(db, "restaurants", id)

        deleteDoc(restaurantDb)
            .then((result) => {
                console.log(result)
                setIsLoading(false)
            })
    }



    function deleteCategory(id) {
        const categoryDb = doc(db, "categories", id)

        deleteDoc(categoryDb)
            .then((result) => {
                console.log(result)
                setIsLoading(false)
                window.history.back()
            })
    }


    function buildStorageFileName(fileName) {
      const lastDotIndex = fileName.lastIndexOf(".");
    
      if (lastDotIndex === -1) {
        return `${fileName}-${v4()}`;
      }
    
      const baseName = fileName.slice(0, lastDotIndex);
      const extension = fileName.slice(lastDotIndex);
    
      return `${baseName}-${v4()}${extension}`;
    }
    
    async function uploadPhotoFile(file) {
      if (!file) return "";
    
      setIsLoading(true);
    
      try {
        const safeFileName = buildStorageFileName(file.name || "photo.jpg");
        const photoRef = ref(storage, `photos/${safeFileName}`);
        const snapshot = await uploadBytes(photoRef, file);
        const url = await getDownloadURL(snapshot.ref);
    
        return url;
      } catch (error) {
        console.log(error);
        return "";
      } finally {
        setIsLoading(false);
      }
    }
    
    async function addPhoto(photo) {
      const url = await uploadPhotoFile(photo);
      setPhotoUrl(url);
      return url;
    }
    
    async function uploadDigitalProductFile(file, restaurantId) {
      if (!file || !restaurantId) return null;
    
      setIsLoading(true);
    
      try {
        const safeFileName = buildStorageFileName(file.name);
        const filePath = `digital-products/${restaurantId}/${safeFileName}`;
        const fileRef = ref(storage, filePath);
    
        const metadata = {
          contentType: file.type || "application/zip",
        };
    
        await uploadBytes(fileRef, file, metadata);

        return {
          name: safeFileName,
          path: filePath,
        };
      } catch (error) {
        console.log(error);
        return null;
      } finally {
        setIsLoading(false);
      }
    }

    async function getDigitalFileUrl(filePath) {
      if (!filePath) return "";
      try {
        return await getDownloadURL(ref(storage, filePath));
      } catch (error) {
        console.log(error);
        return "";
      }
    }

    

  


    
    
   
    
    

    const addToBasket = (item) => {
      setBasket((prev) => {
        const idx = prev.findIndex((x) => x.key === item.key);
    
        // ❌ si pas trouvé → nouvelle ligne
        if (idx === -1) return [...prev, item];
    
        // ✅ si trouvé → on ajoute la quantité
        const next = [...prev];
    
        const existing = next[idx];
    
        const newQuantity = (existing.quantity || 0) + (item.quantity || 0);
    
        const unitPrice = item.pricing.unitPrice;
    
        next[idx] = {
          ...existing,
          quantity: newQuantity,
          pricing: {
            ...existing.pricing,
            unitPrice,
            totalPrice: unitPrice * newQuantity,
          },
        };
    
        return next;
      });
    };
    
    const removeFromBasket = (index) => {
      setBasket((prev) => prev.filter((_, i) => i !== index));
    };
    
    const clearBasket = () => setBasket([]);
    
    const basketTotalQuantity = basket.reduce((sum, it) => sum + (it.quantity || 0), 0);
    
    const basketTotalPrice = basket.reduce(
      (sum, it) => sum + (it.pricing?.totalPrice || 0),
      0
    );

    const updateBasketQty = (index, nextQty) => {
      setBasket((prev) => {
        // si <= 0 => on supprime la ligne
        if (nextQty <= 0) return prev.filter((_, i) => i !== index);
    
        // sinon on met à jour la quantité + total
        return prev.map((it, i) => {
          if (i !== index) return it;
          const unit = it.pricing?.unitPrice || 0;
          return {
            ...it,
            quantity: nextQty,
            pricing: {
              ...(it.pricing || {}),
              totalPrice: unit * nextQty,
            },
          };
        });
      });
    };


    function getOrdersClient(uid) {
      if (!uid) {
        setOrdersClient([]);
        return () => {};
      }
    
      const q = query(
        collection(db, "orders"),
        where("customerId", "==", uid),
        orderBy("createdAt", "desc")
      );
    
      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          setOrdersClient(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
          );
        },
        (error) => {
          console.log("Orders listener error:", error);
        }
      );
    
      return unsubscribe;
    }



    async function getInformationsClient() {
      if (!currentUser?.uid) return null;
      return await refreshUserProfile(currentUser.uid);
    }
    
    async function saveInformationsClient({ firstName, email, address, promoOptOut }) {
      if (!currentUser?.uid) throw new Error("Missing user");
    
      const payload = {
        uid: currentUser.uid,
        role: userProfile?.role || "customer",
        authProvider: userProfile?.authProvider || "phone",
        phone: userProfile?.phone || currentUser?.phoneNumber || null,
        email: email ?? null,
        firstName: firstName ?? null,
        address: address ?? null,
        promoOptOut: typeof promoOptOut === "boolean" ? promoOptOut : null,
        photoURL: currentUser.photoURL ?? null,
        displayName: currentUser.displayName ?? null,
      };
    
      await upsertUserProfile(payload);
      return payload;
    }




    function getCustomerOrders(uid) {
      if (!uid) {
        setOrdersList([]);
        return () => {};
      }
    
      setIsLoading(true);
    
      const ordersQuery = query(
        collection(db, "orders"),
        where("customerId", "==", uid),
        orderBy("createdAt", "desc")
      );
    
      const unsubscribe = onSnapshot(
        ordersQuery,
        (data) => {
          setOrdersList(
            data.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
          );
          setIsLoading(false);
        },
        (error) => {
          console.log("Error getCustomerOrders:", error);
          setIsLoading(false);
        }
      );
    
      return unsubscribe;
    }


    function getRestaurantOrders(restaurantId) {
      if (!restaurantId) {
        setOrdersList([]);
        return () => {};
      }
    
      setIsLoading(true);
    
      const ordersQuery = query(
        collection(db, "orders"),
        where("restaurantId", "==", restaurantId),
        orderBy("createdAt", "desc")
      );
    
      const unsubscribe = onSnapshot(
        ordersQuery,
        (data) => {
          setOrdersList(
            data.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
          );
          setIsLoading(false);
        },
        (error) => {
          console.log("Error getRestaurantOrders:", error);
          setIsLoading(false);
        }
      );
    
      return unsubscribe;
    }

    function updateOrderStatus(id, status) {
      setIsLoading(true);
    
      const orderDb = doc(db, "orders", id);
    
      updateDoc(orderDb, { status })
        .then(() => {
          setIsLoading(false);
          setOrderMessage("Order updated.");
          setTimeout(() => {
            setOrderMessage("");
          }, 3000);
        })
        .catch((error) => {
          console.log("Error updateOrderStatus:", error);
          setIsLoading(false);
        });
    }

    function getOrder(id) {
      if (!id) {
        setCurrentOrder(null);
        return () => {};
      }
    
      setIsLoading(true);
    
      const orderDb = doc(db, "orders", id);
    
      const unsubscribe = onSnapshot(
        orderDb,
        (result) => {
          if (result.exists()) {
            setCurrentOrder({
              ...result.data(),
              id: result.id,
            });
          } else {
            setCurrentOrder(null);
          }
          setIsLoading(false);
        },
        (error) => {
          console.log("Error getOrder:", error);
          setIsLoading(false);
        }
      );
    
      return unsubscribe;
    }


    function waitForOrderPaid(orderId, timeoutMs = 45000) {
      return new Promise((resolve, reject) => {
        if (!orderId) {
          reject(new Error("Missing orderId"));
          return;
        }
    
        const orderRef = doc(db, "orders", orderId);
    
        const timer = setTimeout(() => {
          if (unsubscribe) unsubscribe();
          reject(new Error("Timeout waiting for paid order"));
        }, timeoutMs);
    
        const unsubscribe = onSnapshot(
          orderRef,
          (snap) => {
            if (!snap.exists()) return;
    
            const data = { id: snap.id, ...snap.data() };
    
            if (data.status === "paid") {
              clearTimeout(timer);
              unsubscribe();
              resolve(data);
              return;
            }
    
            if (data.status === "payment_failed" || data.status === "cancelled") {
              clearTimeout(timer);
              unsubscribe();
              reject(new Error("Payment failed"));
            }
          },
          (error) => {
            clearTimeout(timer);
            unsubscribe();
            reject(error);
          }
        );
      });
    }

    async function getPlatformSettings() {
      try {
        const refDoc = doc(db, "settings", "platform");
    
        const snap = await getDoc(refDoc);
    
        if (snap.exists()) {
          setPlatformSettings(snap.data());
        } else {
          setPlatformSettings(null);
        }
    
      } catch (err) {
        console.log("getPlatformSettings error", err);
      }
    }








        function pages(whereIAm) {
          setPage(whereIAm)
          /// console.log(page)
        }





// 6) onAuthStateChanged: charge le userProfile dès qu'un user est connecté
useEffect(() => {
  setAuthReady(false);

  const unsub = auth.onAuthStateChanged(async (user) => {
    setCurrentUser(user);
    setUserProfile(null);
    setUserProfileLoading(!!user);

    if (!user) {
      setPlatformSettings(null);
      setAuthReady(true);
      return;
    }

    await refreshUserProfile(user.uid);
    await getPlatformSettings();
    setAuthReady(true);
  });

  return unsub;
}, []);

   const value = {
    currentUser,
    signup,
    signout,
    auth,
    usernane,
    name,
    postChallenges,
    isLoading,
    listChallenges,
    page,
    pages,    
   
  
    screenSize,
    getCurrentDimension,
    getRestaurants,
    listRestaurants,
    getRestaurant,
    currentRestaurant,
    getProducts,
    listProducts,
    getProduct,
    currentProduct,
    getCategories,
    getcategory,
    listCategories,
    currentCategory,
    postProduct,
    postCategory,
    postRestaurant,
    updateRestaurant,
    updateCategory,
    updateProduct,
    deleteProduct,
    deleteRestaurant,
    deleteCategory,
    categoryM,
    productM,
    newChallengeM,
    restaurantM,
    photoUrl,
    addPhoto,
    changeLanguage,
    language,
    t,
    t2,
    tOption,
    translatedOpt,
    translated,
    translated2,
    languages,
    isProducts,
    ai,
    generated,
    isgenerating,
    sendMessage,
    getArticle,
    getArticles,
    articles,
    currentArticle,
    getCategoriesCMS,
    categoriesCMS,
    basket,
addToBasket,
removeFromBasket,
clearBasket,
basketTotalQuantity,
basketTotalPrice,
updateBasketQty,
userProfile,
setUserProfile, // utile si tu veux refresh après upsert
userProfileLoading,
isProfileComplete,
upsertUserProfile,
refreshUserProfile,
finalizeSignup,
afterPhoneOtpLogin,
ordersClient,
getOrdersClient,
getInformationsClient,
saveInformationsClient,
ordersList,
setOrdersList,
orderMessage,
currentOrder,
setCurrentOrder,
getCustomerOrders,
getRestaurantOrders,
getOrder,
updateOrderStatus,
waitForOrderPaid,
platformSettings,
updateRestaurantStripeData,
authReady,
uploadDigitalProductFile,
getDigitalFileUrl,
uploadPhotoFile,


   }

  return (
    <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
  )
}

